import Vue from 'vue'
import VueRouter from 'vue-router'

// import coach from './modules/coach'
// import center from './modules/center'
// import org from './modules/org'
// import leader from './modules/leader'
// import squad from './modules/squad'
// import playerManagement from './modules/player'
// import tutorial from './modules/tutorial'
// import training from './modules/training'
import { constantRoutes } from '@/router/modules/allRoutes'
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

Vue.use(VueRouter)
const createRouter = () => new VueRouter({
  mode: 'history', // require service support
  routes: constantRoutes
})
const router = createRouter()
export default router
// export default new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes: [
//     {
//       path: '*',
//       redirect: '/login'
//     },
//     {
//       path: '/login',
//       name: 'Login',
//       component: () => import('@/views/login/Login')
//     },
//     {
//       path: '/home',
//       name: 'Home',
//       redirect: '/home/index',
//       component: () => import('@/components/layout'),
//       meta: { requiresAuth: true },
//       children: [
//         {
//           path: 'index',
//           component: () => import('@/views/home'),
//           meta: { requiresAuth: true }
//         }
//       ]
//     },
//     {
//       path: '/setting',
//       name: 'Setting',
//       component: () => import('@/components/layout'),
//       meta: { requiresAuth: true },
//       children: [
//         {
//           path: 'personal',
//           component: () => import('@/views/setting/Personal'),
//           meta: { requiresAuth: true }
//         },
//         {
//           path: 'unit',
//           component: () => import('@/views/setting/Unit'),
//           meta: { requiresAuth: true }
//         }
//       ]
//     },
//     coach,
//     center,
//     leader,
//     squad,
//     playerManagement,
//     tutorial,
//     training,
//     org
//   ]
// })
